import {RECEIVE_PROMOCIONES} from '../actions/PromocionesActions';
import {combineReducers} from 'redux';

function productosPromocionById(state = {
    isFetching: false,
    didInvalidate: true,
    productosPromocion: []
}, action) {
    switch (action.type) {
        case RECEIVE_PROMOCIONES:
            return Object.assign({}, state, {
                isFetching: false,
                didInvalidate: false,
                productosPromocion: action.promociones.entities.producto_promocion,
                lastUpdated: action.receivedAt
            });
        default:
            return state
    }
}

function allProductosPromocion(state = [], action) {
    switch (action.type) {
        case RECEIVE_PROMOCIONES:
            return Object.keys(action.promociones ? action.promociones.entities.producto_promocion : []);
        default:
            return state
    }
}


const productosPromocion = combineReducers({
    byId: productosPromocionById,
    allIds: allProductosPromocion
});

export default productosPromocion;


// WEBPACK FOOTER //
// ./src/reducers/productosPromocion.js